/** @format */
import { Model } from '@toucan/client/global/model';

export const UNLISTED_MODEL_ID = 1;

export const nullModel: Model = {
    id: 0,
    name: '',
    urlSegment: '',
    images: [],
    heroImage: {
        id: 0,
        image: '',
        fileName: '',
        imageUrl: '',
        thumb: '',
        title: '',
        alt: '',
    },
    productType: '',
    primaryCategoryId: 0,
    newSku: 0,
    minOnlinePrice: '',
    featuredText: '',
    description: '',
    legend: '',
    modelSpecs: [
        {
            type: '',
            name: '',
            value: 0,
            displayValue: '',
        },
    ],
    keyFeatures: [],
    newPrice: 0,
    brand: {
        id: 0,
        parentCategoryId: 0,
        name: '',
        type: '',
        uid: 0,
        popularity: 0,
        sorting: 0,
    },
    availability: [
        {
            department: '',
            count: 6,
            minPrice: '',
        },
    ],
    essentialAccessories: [],
    suggestedAccessories: [],
    expectedPriceModifiers: [],
    bonusPriceModifiers: [],
};
